const getRedirectUri = () => {
  if (typeof window !== "undefined" && window.location) {
    return `${window.location.origin}/login/callback`;
  }
  return process.env.OKTA_REDIRECT_URI;
};

const environments = {
  local: {
    issuer: process.env.LOCAL_OKTA_ISSUER_URL,
    clientId: process.env.LOCAL_OKTA_CLIENTID,
    redirectUri: getRedirectUri(),
    scopes: ["openid", "profile", "email", "offline_access"],
    pkce: true,
  },
  staging: {
    issuer: process.env.STAG_OKTA_ISSUER_URL,
    clientId: process.env.STAG_OKTA_CLIENTID,
    redirectUri: getRedirectUri(),
    scopes: ["openid", "profile", "email", "offline_access"],
    pkce: true,
  },
  production: {
    issuer: process.env.PROD_OKTA_ISSUER_URL,
    clientId: process.env.PROD_OKTA_CLIENTID,
    redirectUri: getRedirectUri(),
    scopes: ["openid", "profile", "email", "offline_access"],
    pkce: true,
  },
};

export const getOktaConfigForEnvironment = (environment) => {
  if (!environment) {
    throw new Error("Environment must be specified");
  }

  const env = environment.toLowerCase();
  if (!environments[env]) {
    throw new Error(
      `Unknown environment: ${environment}. Must be 'local', 'staging', or 'production'`
    );
  }

  return {
    ...environments[env],
  };
};

export const getAvailableEnvironments = () => {
  return Object.keys(environments);
};

export default environments;
